import { Card, CardContent, CardMedia, Stack, Typography } from "@mui/material"
import { NO_IMAGE } from "../../config/config";

const ArticleCardSkeleton = ({ index = 0 }) => {
    return (
        <Card
            sx={{
                borderRadius: 1
            }}
        >
            <CardMedia
                image={NO_IMAGE}
                component="img"
                height={170}
            />
            <CardContent>
                <Typography variant={'h6'} mb={0.5} > Article {index + 1}</Typography>
                <Typography variant={'caption'} >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.</Typography>
            </CardContent>
        </Card>
    )
};

export default ArticleCardSkeleton;